export default [
  /**
   * 医生名片
   */
  {
    path: '/doc/card/:id',
    component: () => import('../pages/doc/card')
  },
  /**
   * 申请咨询须知
   **** query
   * id 医生id
   */
  {
    path: '/doc/application',
    meta: {
      title: '申请须知'
    },
    component: () => import('../pages/doc/application')
  },
]



// WEBPACK FOOTER //
// ./src/router/doc.js